import React, { useState } from "react";
import AddressQuestion from "./AddressQuestion";
import ChildQuestion from "./ChildQuestion";
import SpouseDoBQuestion from "./SpouseDoBQuestion";
import DropDownQuestion from "./DropDownQuestion";
import InputQuestion from "./InputQuestion";
import SpouseNameQuestion from "./SpouseNameQuestion";
import NumDropQuestion from "./NumDropQuestion";
//import FormData from "./QD.json";
import NewRadio from "./NewRadio";
import CurrencyQuestion from "./CurrencyQuestion";
import ChildrenQuestion from "./ChildrenQuestion";
import VehicleQuestion from "./VehicleQuestion";

function Question(props) {
  let FormData = props.QDB;
  let selectedItem = FormData.find((item) => item.Code_ID === props.QID);
  let realID = props.QID;
  if (selectedItem === undefined) {
    selectedItem = props.Question;
  }
  if (realID === undefined) {
    realID = selectedItem.Code_ID;
  }
  const [ndv, setNDV] = useState(parseInt(getA()));
  const [Q19B, setQ19B] = useState("Yes");

  function handleValue(event) {
    var val = event.target.value;
    //console.log(`ndv = ${val}`);
    setNDV(val);
    props.handleValue(event);
  }
  /*
  function handleVehicle(event) {
    var val = event.target.value;
    setQ19B(val);
    props.handleValue(event);
  }*/
  function getA() {
    let rv = props.getAnswer(
      selectedItem["New_#"],
      props.QID.includes("_X") ? parseInt(props.QID.split("_X_")[1]) : 0
    );
    //    console.log(selectedItem["Code_ID"], props.QID.split("_X_")[1]);
    return rv;
  }
  function ndvSUBS(Num, vehicle = false) {
    // lists component X times based on N, which should be the NDV state for a num drop question's value
    let N = 0;
    if (isNaN(Num) === false) {
      N = Num;
    }
    //  console.log("N", N);
    var Sub_Questions = Array.from(Array(N).keys());
    if (vehicle === false)
      return (
        <div>
          {Sub_Questions.map((subnum) => {
            return (
              <div key={subnum + 1} className="subQuestionBox">
                <h4> {selectedItem.Enumaration.replaceAll("*", subnum + 1)}</h4>
                {subQuestion(subnum + 1)}
              </div>
            );
          })}
        </div>
      );
    return (
      <div>
        {Sub_Questions.map((subnum) => {
          return (
            <div key={subnum + 1} className="subQuestionBox">
              <VehicleQuestion
                idx={subnum + 1}
                Q19B={Q19B}
                handleValue={props.handleValue}
                QDB={props.QDB}
                getAnswer={props.getAnswer}
              />
            </div>
          );
        })}
      </div>
    );
  }
  function subQuestion(idx) {
    var subQNumbers = selectedItem.Sub_Questions.split("/");
    return subQNumbers.map((sub) => {
      var currentQ = props.getq(sub);
      if (props.sh(currentQ, true)) return <div key={sub}></div>;
      return (
        <div key={sub}>
          {props.Dev ? currentQ["New_#"] : ""}
          <Question
            Question={currentQ}
            QID={`${currentQ.Code_ID}_${idx}`}
            handleValue={props.handleValue}
            QDB={props.QDB}
            getAnswer={props.getAnswer}
            Dev={props.Dev}></Question>
        </div>
      );
    });
  }

  if (selectedItem === undefined || props.hide === true) {
    return <div>undefined</div>;
  }
  switch (selectedItem.Question_Type) {
    case "Name":
      return (
        <SpouseNameQuestion
          QuestionText={selectedItem.QuestionText}
          id={realID}
          handleValue={props.handleValue}
          getAnswer={props.getAnswer}
        />
      );
    case "DOB":
      return (
        <SpouseDoBQuestion
          QuestionText={selectedItem.QuestionText}
          id={realID}
          handleValue={props.handleValue}
          getAnswer={props.getAnswer}
        />
      );
    case "Address":
      return (
        <AddressQuestion
          handleValue={props.handleValue}
          getAnswer={props.getAnswer}
        />
      );
    case "dropdown":
      return (
        <DropDownQuestion
          handleValue={props.handleValue}
          id={selectedItem.Code_ID}
          QuestionText={selectedItem.QuestionText}
          GuidelineText={selectedItem.GuideText}
          Section={selectedItem.Section}
          Choices={selectedItem.Choices.split("/")}
          Answer={getA()}
        />
      );
    case "Children":
      return (
        <ChildrenQuestion
          id="num_Children"
          QuestionText="How Many Children do you have? "
          GuidelineText=""
          Section="profile"
          handleValue={props.handleValue}
          Answer={getA()}>
          <ChildQuestion getAnswer={props.getAnswer} />
        </ChildrenQuestion>
      );
    case "num_dropdown":
      return (
        <div>
          <NumDropQuestion
            id={realID}
            QuestionText={selectedItem.QuestionText}
            GuidelineText={selectedItem.GuideText}
            handleValue={handleValue}
            Answer={getA()}></NumDropQuestion>
          {ndvSUBS(parseInt(ndv))}
        </div>
      );
    case "radio":
      return (
        <NewRadio
          id={realID}
          QuestionText={selectedItem.QuestionText}
          GuidelineText={selectedItem.GuideText}
          Choices={selectedItem.Choices.split("/")}
          handleValue={props.handleValue}
          Answer={getA()}
        />
      );
    case "currency":
      return (
        <CurrencyQuestion
          id={realID}
          QuestionText={selectedItem.QuestionText}
          GuidelineText={selectedItem.GuideText}
          Section={selectedItem.Section}
          handleValue={props.handleValue}
          Answer={getA()}
        />
      );
    case "percent":
      return (
        <InputQuestion
          id={realID}
          QuestionText={selectedItem.QuestionText}
          GuidelineText={selectedItem.GuideText}
          Section={selectedItem.Section}
          handleValue={props.handleValue}
          Symbol=""
          Post="%"
          Unit="percent"
          Answer={getA()}
        />
      );
    case "vehicle":
      return (
        <div>
          <NumDropQuestion
            id={realID}
            QuestionText={selectedItem.QuestionText}
            GuidelineText={selectedItem.GuideText}
            handleValue={handleValue}
            Answer={getA()}></NumDropQuestion>

          {ndvSUBS(parseInt(ndv), true)}
        </div>
      );
    default:
      return (
        <InputQuestion
          id={realID}
          QuestionText={selectedItem.QuestionText}
          GuidelineText={selectedItem.GuideText}
          Section={selectedItem.Section}
          handleValue={props.handleValue}
          Symbol=""
          Post={selectedItem.Question_Type}
          Unit=""
          Answer={getA()}
        />
      );
  }
}

export default Question;
